export enum RoutePaths {
  Default = '/',
  Login = 'login',
  ForgotPassword = 'forgot-password',
  Configurations = 'configurations',
  EditConfiguration = 'edit-configuration',
  NewConfiguration = 'new-configuration',
  Algorithms = 'algorithms',
  AddAlgorithm = 'add-algorithm',
  EditAlgorithm = 'edit-algorithm',
  Connections = 'connections',
  EditConnection = 'edit-connection',
  Metrics = 'metrics',
  Studies = 'studies',
  AddStudy = 'add-study',
  Settings = 'settings',
}
